import React from 'react';
import { Flex, Spacer, Box, Divider } from '@chakra-ui/react';

const DemoCalendar = () => {
  return (
    <Box>
      <h2>Calendar</h2>
      <Divider m={2} />
      <Flex align={'center'}>
        <p></p>
        <Spacer />
        <Box></Box>
      </Flex>
    </Box>
  );
};

export default DemoCalendar;
